module.exports = __webpack_public_path__ + "static/img/smart_guard.4bea9f6c.png";